module.exports = __webpack_public_path__ + "img/Check.d8dbf775.svg";